export default __webpack_public_path__ + "static/media/Arrow_Growth_Icon.bea9fcd5.svg";